import { useEffect, useState } from 'react';

import { useLazyQuery } from '@apollo/client';
import { Country, CountryCurrency } from '@prisma/client';

import { useAuthContext } from 'src/contexts/AuthProvider';
import { GET_DEFAULT_CURRENCY } from 'src/graphql/queries/countries.query';

interface CurrencyProps extends Partial<Country> {
    currencies?: CountryCurrency[];
}

export const useCurrency = (country?: Partial<CurrencyProps>) => {
    const { usersCurrency } = useAuthContext();

    const countryCurrencySymbol = country?.currencies?.[0]?.symbol;

    const [currencySymbol, setCurrencySymbol] = useState<string>(countryCurrencySymbol || '');

    const [getDefaultCurrency] = useLazyQuery(GET_DEFAULT_CURRENCY, {
        fetchPolicy: 'cache-and-network',
        onCompleted: (data) => {
            setCurrencySymbol(data.getDefaultCurrency.symbol);
        },
    });

    useEffect(() => {
        if (countryCurrencySymbol) {
            setCurrencySymbol(countryCurrencySymbol);
        } else if (usersCurrency) {
            setCurrencySymbol(usersCurrency);
        } else {
            getDefaultCurrency();
        }
    }, [countryCurrencySymbol, usersCurrency, getDefaultCurrency]);

    return { currencySymbol };
};
